import { useMutation } from '@tanstack/react-query'
import { useCartContext } from '../components'

export const useUpdateCart = () => {
  const { cartManager } = useCartContext()
  return useMutation({ mutationFn: cartManager.update })
}
